import {
  emailFields,
  requiredFields,
  validateHoneypot,
  validate,
} from 'utils/forms';

export default validate(
  validateHoneypot,
  emailFields('email'),
  requiredFields('name', 'email', 'message'),
);
